module.exports = __webpack_public_path__ + "media/images/logo-large-30a5272fa7df4a3a1e2f0c3ffe0260c4.png";